const NBPQuery = 'https://api.nbp.pl/api/exchangerates/tables/c/'

export default NBPQuery
